<template>
  <div id="feature-popup" class="rounded" @mousedown="initResize">
    <div :id="popupResizableId" :style="{ width: currentWidth, height: currentHeight }">
      <b-row class="mb-1">
        <b-col id="feature-popup-header">
          <h6 v-if="featurePopupHeader" class="font-weight-bold">{{featurePopupHeader}}</h6>
        </b-col>
        <b-col md="auto">
          <a href="#" id="feature-popup-close" class="float-right text-secondary" @click="closePopup"></a>
        </b-col>
      </b-row>
      <div :id="popupContentId">
        <div class="table-responsive">
          <table class="table table-bordered col-md-12">
            <tbody v-if="featurePopupAttributes && featurePopupAttributes.length">
              <tr v-for="(attr, index) in featurePopupAttributes" :key="attr.key + '-' + index" v-if="keyIsNotIgnored(attr.key)">
                <td>
                  {{attr.key}}
                </td>
                <td v-if="attr.isLink">
                  <a :href="attr.val" target="_blank" rel="noopener noreferrer">{{attr.val}}</a>
                </td>
                <td v-else-if="attr.isFileList">
                  <ul>
                    <li v-for="item in attr.val" :key="item.path">
                      <a href="#" @click="downloadFile(item)"> {{ item.name }} </a>
                    </li>
                  </ul>
                </td>
                <td v-else-if="dateKeysContains(attr.key)">
                  {{ getFormattedDateString(attr.val) }}
                </td>
                <td v-else>
                  <feature-popup-parsed-attr-value :attrVal="attr.val"></feature-popup-parsed-attr-value>
                </td>
              </tr>
            </tbody>
            <tbody v-if="featurePopupHtml">
              <div v-html="featurePopupHtml"></div>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { SELECT_FEATURE_POPUP_HIDE } from "../store/mutations.type";
import {Api as ApiStawki} from "../api/api-stawki";
import SettingsInstance from "../api/SettingsInstance";
import FeaturePopupParsedAttrValue from "./FeaturePopupParsedAttrValue";

const START_WIDTH = 500;
const START_HEIGHT = 400;

export default {
  name: "FeaturePopup",
  components: {
    FeaturePopupParsedAttrValue
  },
  data: function() {
    return {
      popupContentId: "feature-popup-content",
      popupResizableId: "feature-popup-resizable",
      startX: null,
      startY: null,
      startWidth: START_WIDTH,
      width: START_WIDTH,
      minWidth: 120,
      maxWidth: 850,
      startHeight: START_HEIGHT,
      height: START_HEIGHT,
      minHeight: 100,
      maxHeight: 850,
      ignoredKeys: ['id'],
      // klucze dla dat - powiazane z taskiem #34484
      datesKeys: [
        "Z.2.II.6. Przewidywana data rozpoczęcia robót budowlanych.",
        "Z.2.III.6. Przewidywana data rozpoczęcia robót budowlanych.",
        "Z.2.IV.6. Przewidywana data rozpoczęcia robót budowlanych."
      ]
    };
  },
  computed: {
    ...mapGetters([
      "featurePopupAttributes",
      "featurePopupHeader",
      "featurePopupHtml"
    ]),
    currentWidth() {
      return this.width + "px";
    },
    currentHeight() {
      return this.height + "px";
    }
  },
  mounted() {
    let self = this;
    self.$store.watch(
      () => self.$store.getters.featurePopupPosition,
      (value, oldValue) => {
        var el = document.getElementById(self.popupContentId);
        // el.scrollTop = 0;
        this.width = START_WIDTH;
        this.height = START_HEIGHT;
      }
    );
  },
  methods: {
    async downloadFile(item){
      if(item.apiAction && item.apiAction=="getStawkiZalacznikiByPath"){
        let baseUrl = SettingsInstance.baseApiUrl.trim("/");
        baseUrl += '/stawki_zalaczniki/' + item.path;
        window.location = baseUrl;
      }
    },
    keyIsNotIgnored(key) {
      return !this.ignoredKeys.includes(key);
    },
    closePopup() {
      this.$store.commit(SELECT_FEATURE_POPUP_HIDE);
    },
    initResize(e) {
      if (e.target && e.target.id === this.popupResizableId) {
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.startWidth = this.width;
        this.startHeight = this.height;
        document.documentElement.addEventListener(
          "mousemove",
          this.resize,
          false
        );
        document.documentElement.addEventListener(
          "mouseup",
          this.stopResize,
          false
        );
      }
    },
    resize(e) {
      e.stopPropagation();
      e.preventDefault();
      let width = this.startWidth + e.clientX - this.startX;
      let height = this.startHeight + e.clientY - this.startY;
      if (width >= this.minWidth && width <= this.maxWidth) {
        this.width = width;
      }
      if (height >= this.minHeight && height <= this.maxHeight) {
        this.height = height;
      }
    },
    stopResize(e) {
      document.documentElement.removeEventListener(
        "mousemove",
        this.resize,
        false
      );
      document.documentElement.removeEventListener(
        "mouseup",
        this.stopResize,
        false
      );
    },
    dateKeysContains(key) {
      return this.datesKeys.indexOf(key) > -1;
    },
    getFormattedDateString(value) {
      return value.toString().substring(0,10);
    }
  }
};
</script>
